import React, { useState, useEffect } from 'react';

const TweetTyping = () => {
  const [text, setText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const [isComplete, setIsComplete] = useState(false);
  const fullText = "Connect with massive audiences on platforms that shape culture and bring communities together @WilinWorld";

  useEffect(() => {
    if (text.length < fullText.length) {
      const timeout = setTimeout(() => {
        setText(fullText.slice(0, text.length + 1));
      }, 30); // Reduced from 50ms to 30ms for faster typing

      return () => clearTimeout(timeout);
    } else {
      setIsComplete(true);
    }
  }, [text]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <div className="max-w-2xl bg-black/80 rounded-xl p-6 border border-gray-800">
      <div className="flex items-center mb-4">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-yellow-400 via-pink-500 to-purple-500 p-[2px]">
          <div className="w-full h-full rounded-full overflow-hidden bg-black">
            <div className="w-full h-full relative">
              {/* Frog Avatar */}
              <div className="absolute inset-0 bg-green-500 rounded-full">
                <div className="absolute inset-1 bg-gradient-to-br from-green-400 to-green-600 rounded-full">
                  {/* Eyes */}
                  <div className="absolute top-[25%] left-[25%] w-2 h-2 bg-white rounded-full">
                    <div className="absolute top-[25%] left-[25%] w-1 h-1 bg-black rounded-full" />
                  </div>
                  <div className="absolute top-[25%] right-[25%] w-2 h-2 bg-white rounded-full">
                    <div className="absolute top-[25%] left-[25%] w-1 h-1 bg-black rounded-full" />
                  </div>
                  {/* Smile */}
                  <div className="absolute top-[60%] left-1/2 -translate-x-1/2 w-4 h-2 border-b-2 border-black rounded-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ml-3">
          <p className="font-bold text-white">Wilin World</p>
          <p className="text-gray-500">@WilinWorld</p>
        </div>
      </div>
      <div className="text-white text-xl">
        {text}
        <span 
          className={`inline-block w-0.5 h-5 bg-green-500 ml-1 ${showCursor ? 'opacity-100' : 'opacity-0'} ${isComplete ? 'animate-pulse' : ''}`}
        ></span>
      </div>
      {isComplete && (
        <div className="mt-4 flex items-center text-gray-500 space-x-8">
          <div className="flex items-center space-x-2 group cursor-pointer">
            <svg className="w-5 h-5 group-hover:text-green-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
            <span className="group-hover:text-green-500 transition-colors">42.5K</span>
          </div>
          <div className="flex items-center space-x-2 group cursor-pointer">
            <svg className="w-5 h-5 group-hover:text-green-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            <span className="group-hover:text-green-500 transition-colors">18.2K</span>
          </div>
          <div className="flex items-center space-x-2 group cursor-pointer">
            <svg className="w-5 h-5 group-hover:text-green-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
            <span className="group-hover:text-green-500 transition-colors">96.1K</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TweetTyping; 